import TagManager, { TagManagerArgs } from 'react-gtm-module'

import { localeStorageGet, COOKIES_KEY } from '../storage'

/**
 * Google Tag Manager
 *  https://www.npmjs.com/package/react-gtm-module
 */
class GTM {
  private isCookies = true

  public start() {
    const tagManagerArgs: TagManagerArgs = {
      gtmId: `${process.env.REACT_APP_GA_ID}`,
    }

    TagManager.initialize(tagManagerArgs)
  }

  public on() {
    this.isCookies = true
  }

  public off() {
    this.isCookies = false
  }

  private dataLayer() {
    return (window as any)?.dataLayer
  }

  private shouldPush() {
    if (!this.isCookies) return false

    const isProduction = process.env.REACT_APP_ENV !== 'development'
    const cookiesStorage = localeStorageGet(COOKIES_KEY)

    const shouldPush = isProduction && cookiesStorage === 'done'
    return shouldPush
  }

  public event = {
    accepted_cookies_click: () => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'accepted_cookies_click',
          eventCategory: 'Engagement',
          eventAction: 'Accepted Cookies',
          eventLabel: '',
        })
      }
    },
    launch_button: () => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'launch_button_click',
          eventCategory: 'Engagement',
          eventAction: 'Launch',
          eventLabel: '',
        })
      }
    },
    camera_access_click: (label: 'Allowed' | 'Denied') => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'camera_access_click',
          eventCategory: 'Engagement',
          eventAction: 'Camera Access',
          eventLabel: `${label}`,
        })
      }
    },
    back_button_click: () => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'back_button_click',
          eventCategory: 'Engagement',
          eventAction: 'Back',
          eventLabel: '',
        })
      }
    },
    camera_reverse_click: () => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'camera_reverse_click',
          eventCategory: 'Engagement',
          eventAction: 'Reverse Camera',
          eventLabel: '',
        })
      }
    },
    take_photo_click: () => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'take_photo_click',
          eventCategory: 'Engagement',
          eventAction: 'Take Photo',
          eventLabel: '',
        })
      }
    },
    save_photo_click: () => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'save_photo_click',
          eventCategory: 'Engagement',
          eventAction: 'Save Photo',
          eventLabel: '',
        })
      }
    },
    share_button_click: (label = 'Share Crayola Shark') => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'share_button_click',
          eventCategory: 'Engagement',
          eventAction: 'Share',
          eventLabel: `{{${label}}}`,
        })
      }
    },
    reset_button_click: () => {
      if (this.shouldPush()) {
        this.dataLayer()?.push({
          event: 'reset_button_click',
          eventCategory: 'Engagement',
          eventAction: 'Reset',
          eventLabel: '',
        })
      }
    },
  }
}

const Analytics = new GTM()
export default Analytics
